import { DefaultChatTransport, readUIMessageStream, type UIMessage } from "ai";

const transport = new DefaultChatTransport({
	api: "/api/chat",
});

export type GroupUiMessage = UIMessage;

export function extractTextFromUiMessage(message?: UIMessage | null): string {
	if (!message) {
		return "";
	}

	return message.parts
		.filter((part) => part.type === "text")
		.map((part) => part.text)
		.join("");
}

export function isAbortLikeError(error: unknown): boolean {
	return (
		(error instanceof DOMException && error.name === "AbortError") ||
		(error instanceof Error && error.name === "AbortError")
	);
}

export async function streamGroupChatResponse({
	messages,
	model,
	noFallback,
	abortSignal,
	onTextUpdate,
}: {
	messages: UIMessage[];
	model: string;
	noFallback: boolean;
	abortSignal: AbortSignal;
	onTextUpdate?: (payload: { message: UIMessage; text: string }) => void;
}): Promise<UIMessage | undefined> {
	const stream = await transport.sendMessages({
		abortSignal,
		body: { model },
		chatId: crypto.randomUUID(),
		headers: noFallback ? { "x-no-fallback": "true" } : undefined,
		messageId: undefined,
		messages,
		trigger: "submit-message",
	});

	let finalMessage: UIMessage | undefined;

	for await (const message of readUIMessageStream({
		stream,
		terminateOnError: true,
	})) {
		finalMessage = message;
		onTextUpdate?.({
			message,
			text: extractTextFromUiMessage(message),
		});
	}

	return finalMessage;
}
